import _ from 'underscore'
import moment from 'moment'

export default class User {
	constructor() {
		this.userId = undefined

		this.firstName = undefined
		this.lastName = undefined

		this.email = undefined
		this.authToken = undefined
		this.authTokenDate = undefined

		this.isAdmin = false
		this.isAdvanced = true

		this.created = undefined
		this.modified = undefined
		this.deleted = undefined

	}

	static default() {
		return User.buildFromJson({
			firstName: '',
			lastName: '',
			isAdmin: false,
		})
	}

	static buildFromJson(source = undefined) {
		if(source !== undefined) {
			var result = new User()

			result.userId = source.userId

			result.firstName = source.firstName
			result.lastName = source.lastName

			result.email = source.email
			result.authToken = source.authToken
			result.authTokenDate = source.authTokenDate

			result.isAdmin = source.isAdmin
			result.isAdvanced = source.isAdmin || source.isAdvanced

			result.created = source.created
			result.modified = source.modified
			result.deleted = source.deleted

			return result
		}
		return undefined
	}

	static buildFromJsonArray(sourceArray = []) {
		var result = []

		for(var json of sourceArray) {
			var model = User.buildFromJson(json)
			if(model !== undefined) {
				result.push(model)
			}
		}

		return result
	}
}



// WEBPACK FOOTER //
// ./src/model/User.js